import { IPagination } from 'app/types/common';

export interface IRemindersState {
  readonly remindersById?: any;
  readonly reminderIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectReminderLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly success?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationReminderIds?: string[];
  readonly currentReminderId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IRemindersSelector extends IRemindersState {
  readonly currentReminder?: any;
  readonly currentFormReminder?: any;
  readonly remindersFilteredByTagInSelectFormat?: any;
  readonly remindersByIdInSelectFormat?: any;
  readonly remindersFilteredByOrganisationInSelectFormat?: any;
}

export enum RemindersActionTypes {
  GET_ALL_REMINDERS_REQUESTED = 'redux-app/reminders/GET_ALL_REMINDERS_REQUESTED',
  GET_ALL_REMINDERS_PENDING = 'redux-app/reminders/GET_ALL_REMINDERS_PENDING',
  GET_ALL_REMINDERS_SUCCESS = 'redux-app/reminders/GET_ALL_REMINDERS_SUCCESS',
  GET_ALL_REMINDERS_FAIL = 'redux-app/reminders/GET_ALL_REMINDERS_FAIL',
  GET_REMINDER_REQUESTED = 'redux-app/reminders/GET_REMINDER_REQUESTED',
  GET_REMINDER_PENDING = 'redux-app/reminders/GET_REMINDER_PENDING',
  GET_REMINDER_SUCCESS = 'redux-app/reminders/GET_REMINDER_SUCCESS',
  GET_REMINDER_FAIL = 'redux-app/reminders/GET_REMINDER_FAIL',
  UPDATE_REMINDER_REQUESTED = 'redux-app/reminders/UPDATE_REMINDER_REQUESTED',
  UPDATE_REMINDER_PENDING = 'redux-app/reminders/UPDATE_REMINDER_PENDING',
  UPDATE_REMINDER_SUCCESS = 'redux-app/reminders/UPDATE_REMINDER_SUCCESS',
  UPDATE_REMINDER_FAIL = 'redux-app/reminders/UPDATE_REMINDER_FAIL',
  CREATE_REMINDER_REQUESTED = 'redux-app/reminders/CREATE_REMINDER_REQUESTED',
  CREATE_REMINDER_PENDING = 'redux-app/reminders/CREATE_REMINDER_PENDING',
  CREATE_REMINDER_SUCCESS = 'redux-app/reminders/CREATE_REMINDER_SUCCESS',
  CREATE_REMINDER_FAIL = 'redux-app/reminders/CREATE_REMINDER_FAIL',
  DELETE_REMINDER_REQUESTED = 'redux-app/reminders/DELETE_REMINDER_REQUESTED',
  DELETE_REMINDER_PENDING = 'redux-app/reminders/DELETE_REMINDER_PENDING',
  DELETE_REMINDER_SUCCESS = 'redux-app/reminders/DELETE_REMINDER_SUCCESS',
  DELETE_REMINDER_FAIL = 'redux-app/reminders/DELETE_REMINDER_FAIL',
  SELECT_REMINDER_REQUESTED = 'redux-app/reminders/SELECT_REMINDER_REQUESTED',
}

export default null;
